/**
 * Turns a tenant's static config (config/<tenant>.json) into what the
 * dashboard needs: the set of enabled dashboard modules and their display
 * names.
 *
 * Platform module keys (left) map to dashboard modules (right). Keys with no
 * dashboard tab yet (doctube, aiAgent, doctors, election, certificate,
 * banner, notification) are ignored. A dashboard module whose key is absent
 * from a tenant's config is treated as disabled for that tenant.
 */

export const CONFIG_TO_MODULE = {
  medwiki: "medwiki",
  clinicalVideo: "video",
  series: "series",
  session: "session",
  spq: "survey",
  course: "training",
  epaper: "epub",
  channel: "channel",
  reel: "reels",
  story: "stories",
  stories: "stories",
  podcast: "podcasts",
  podcasts: "podcasts",
  trends: "trends",
  loyalty: "loyalty",
};

/**
 * @param {{modules?: Record<string, {enabled?: boolean, names?: {brand?: string, one?: string, many?: string, short?: string}}>}} config
 * @returns {{ modules: string[], labels: Record<string, string> }}
 */
export function modulesFromConfig(config) {
  const modules = new Set();
  const labels = {};
  for (const [key, value] of Object.entries(config?.modules ?? {})) {
    const module = CONFIG_TO_MODULE[key];
    if (!module || !value?.enabled) continue;
    modules.add(module);
    // Plural reads best as a tab title and chart label ("Programmes", "Articles").
    const name = value.names?.many || value.names?.brand || value.names?.short;
    if (name) labels[module] = name;
  }
  return { modules: [...modules], labels };
}
